import script from "./Allergens.vue?vue&type=script&setup=true&lang=js"
export * from "./Allergens.vue?vue&type=script&setup=true&lang=js"

import "./Allergens.vue?vue&type=style&index=0&id=5cce3cce&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cce3cce"]])

export default __exports__